import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { FETCH_VENDOR, LIST_VENDORS } from '../graphql/query/vendor.query';
import {
  CREATE_VENDOR,
  REMOVE_VENDOR,
  UPDATE_VENDOR,
} from '../graphql/mutation/vendor.mutation';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  constructor(private apollo: Apollo) {}

  fetchVendors(search: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: LIST_VENDORS,
        variables: {
          search,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.vendors || []));
  }

  bulkCreateCustomer(file: File): Observable<any> {
    const token = localStorage.getItem('AUTH_TOKEN');
    const formData = new FormData();
    formData.append(
      'operations',
      JSON.stringify({
        query: `
          mutation bulkCreatePartners($file: Upload!) {
            bulkCreatePartners(file: $file)
          }
          `,
        variables: { file: null },
      })
    );

    formData.append('map', JSON.stringify({ '0': ['variables.file'] }));
    formData.append('0', file);

    return from(
      fetch(environment.url.projectModuleUrl, {
        method: 'POST',
        body: formData,
        headers: {
          authorization: token ? `Bearer ${token}` : '',
          'x-apollo-operation-name': 'uploadFile',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((result) => result.data?.bulkCreatePartners || result)
    );
  }

  fetchVendorById(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: FETCH_VENDOR,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.vendor || []));
  }

  createVendor(createVendorInput: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: CREATE_VENDOR,
        variables: {
          createVendorInput,
        },
      })
      .pipe(map((result: any) => result.data.createCustomer || []));
  }

  updateVendor(
    updateVendorInput: any,
    id: Number
  ): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: UPDATE_VENDOR,
        variables: {
          updateVendorInput,
          id,
        },
      })
      .pipe(map((result: any) => result.data.updateVendor || []));
  }

  removeVendor(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: REMOVE_VENDOR,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.removeVendor || []));
  }
}
